export default __webpack_public_path__ + "static/media/bujar.3d208134.png";